export default __webpack_public_path__ + "static/media/info-circle.1ae7d5d7.svg";